import type {
  ConditionFieldDescription,
  ConditionsConfig_ConditionConfig,
} from "@smartsuite/automation-engine-api";
import { StyledIcon } from "../../../../../Forms/InputForm/FieldEditor/FieldEditorRow/containers/TriggerOptions/style";
import { useCallback } from "react";
import type { ReactNode } from "react";
import { StyledOptionLabel } from "../../../../../Forms/InputForm/FieldEditor/InputNestedFieldOptions/style";
import { Icon, MenuGroupContent, MenuOption } from "@smartsuite/react-ui/lib";
import { SolutionColorVariables } from "@smartsuite/types";

export const SubConditionOptions: React.FC<{
  condition: ConditionsConfig_ConditionConfig;
  onChange: (condition: ConditionsConfig_ConditionConfig) => void;
  conditionFields: ConditionFieldDescription[];
  onNavigateBack: () => void;
  title?: string;
}> = ({ condition, onChange, conditionFields, title, onNavigateBack }) => {
  const onOptionClick = (
    conditionFieldGroup: ConditionFieldDescription,
  ): void => {
    onChange({
      conditionFieldId: String(conditionFieldGroup.conditionFieldId),
    });
  };

  const getLabelText = useCallback(
    (field: ConditionFieldDescription): string => {
      const isAutoNumberField = field.smartsuiteFieldType === "autonumberfield";
      const labelText =
        field.labelSuffix && !isAutoNumberField
          ? `${field.label}: ${field.labelSuffix}`
          : field.label;
      return labelText;
    },
    [],
  );

  const getLabel = useCallback(
    (field: ConditionFieldDescription): ReactNode => {
      const labelText = getLabelText(field);
      const isAutoNumberField = field.smartsuiteFieldType === "autonumberfield";
      const isAutoNumberEntireField =
        isAutoNumberField && field.labelSuffix === "Entire Field";

      if (isAutoNumberEntireField) {
        return (
          <>
            {labelText}
            <StyledOptionLabel> • Entire Field</StyledOptionLabel>
          </>
        );
      }

      if (!field.labelSuffix && !isAutoNumberField) {
        return (
          <>
            {labelText}
            <StyledOptionLabel> • Entire Field</StyledOptionLabel>
          </>
        );
      }
      return <>{labelText}</>;
    },
    [],
  );

  return (
    <MenuGroupContent
      onNavigateBack={onNavigateBack}
      title={title}
      search={false}
    >
      {conditionFields
        .sort((a, b) => {
          return getLabelText(a).localeCompare(getLabelText(b));
        })
        .map((field) => {
          return (
            <MenuOption
              key={field.conditionFieldId}
              active={field.conditionFieldId === condition.conditionFieldId}
              onClick={() => {
                onOptionClick(field);
              }}
            >
              <>
                <StyledIcon>
                  <Icon
                    name={field.icon}
                    size="S"
                    color={SolutionColorVariables.sc1}
                  />
                </StyledIcon>
                {getLabel(field)}
              </>
            </MenuOption>
          );
        })}
    </MenuGroupContent>
  );
};
